import React, { useState, useMemo, useContext } from "react";
import { Table, Typography, Divider, Popconfirm, Button, message, Row, Col } from "antd";
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import PaymentModal from "../../../paymentModal";
import ViewPayments from "../../../paymentModal/ViewPayments";
import { ContextAPI } from "../../../../ContextAPI";
import { platformApi } from "../../../../api";
import JobOrderModal from "../../JobOrder/JobOrderModal";
import LedgerModal from "../../Ledger/LedgerModal";
import { ENDPOINT } from "../../../../constants";
import VehicleName from "../../../VehicleName";
import { formatVehicleName } from "../../../../utils/vehicleDisplayName";
import "./index.less";

const { Text } = Typography;

const getStatusColor = (text) => {
    if (text === "PENDING") return "#ff4d4f";
    if (text === "ORDERED") return "#ad6800";
    if (text === "PARTIALLY_RECEIVED") return "#d46b08";
    if (text === "PARTIALLY_ORDERED") return "#874d00";
    if (text === "RECEIVED" || text === "ISSUED") return "#237804";
    return "#595959";
};

const CustomerSpareTable = ({
    dataSource,
    openModal,
    delete: deleteData,
    spinner,
    history,
    pagination,
    deleteAccess,
    modifyAccess,
    refreshData
}) => {
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [receiptOpen, setReceiptOpen] = useState(false);
    const [selectedData, setSelectedData] = useState();
    const [jobOrderVisible, setJobOrderVisible] = useState(false);
    const [jobDetail, setJobDetail] = useState();
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);
    const { loginCredintials } = useContext(ContextAPI);

    const hasCashCollectAccess = useMemo(() => {
        if (loginCredintials?.roleAccess) {
            return loginCredintials.roleAccess.some(
                (acc) =>
                    acc.master === "TRANSACTIONMASTER" &&
                    (acc.subModule === "Cash Payment" ||
                        acc.subModule === "POS Machine") &&
                    acc.access.create === true
            );
        }
        return false;
    }, [loginCredintials?.roleAccess]);

    const convertAction = async (type, id) => {
        const url = `/api/customerSpareOrderRouter/${type}/${id}`;
        const successMsg = `${type} Created Successfully`;
        const errorMsg = `Failed To Create ${type}`;

        try {
            const res = await platformApi.post(url);
            if (res?.data?.code === 200) {
                message.success(successMsg);
            } else {
                message.error(errorMsg);
            }
        } catch (err) {
            message.error(errorMsg);
        } finally {
            refreshData();
        }
    };

    const handleConvertedData = (data) => {
        if (data.module === "JOB_CARD") {
            getJobOrder(data.id);
            setJobOrderVisible(true);
        } else if (data.module === "COUNTER_SALE") {
            const url = `/autoadmin/counter_sale/${data.id}`;
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    const getJobOrder = (id) => {
        platformApi.get("/api/jobOrder/" + id).then((res) => {
            const {
                data: {
                    response: { data },
                },
            } = res;
            setJobDetail(data);
        });
    };

    const column = [
        {
            render: (data) => {
                const customerObj = data.partyName || data.customer;
                const registerNo = data.soldVehicle?.registerNo || "-";
                const vehicleLabel = data.soldVehicle?.vehicle
                        ? formatVehicleName(data.soldVehicle.vehicle)
                        : "-";
                const orderDate = data.orderDate
                    ? moment(data.orderDate).format("DD-MM-YYYY")
                    : moment(Date.now()).format("DD/MM/YYYY");
                const statusText = data.overallStatus || "No Orders Found";
                const statusColor = getStatusColor(data.overallStatus);

                return (
                    <div className="box" style={{ backgroundColor: "white", padding: "20px" }}>
                        <Row type="flex" align="top" gutter={12}>
                            <Col span={8} style={{ padding: "0.25rem 0.5rem" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Order Date
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>{orderDate}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Order Number
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                {data.orderNumber || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Order Type
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                {data.orderType || "-"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col span={8} style={{ padding: "0.25rem 0.5rem" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Customer
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                <span
                                                    className="linkylink"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        if (customerObj) {
                                                            setSelectedCustomer(customerObj);
                                                            setCustomerLedgerOpen(true);
                                                        }
                                                    }}
                                                >
                                                    {customerObj?.name || "-"}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Registration No
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>{registerNo}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Vehicle
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                              {vehicleLabel !== "-" ? (
                                                <VehicleName>{vehicleLabel}</VehicleName>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col span={8} style={{ padding: "0.25rem 0.5rem" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Grand Total
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                {data.GrandTotal ?? "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Advance Amount
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                {data.Advance ?? "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "right", fontWeight: "bolder", whiteSpace: "nowrap" }}>
                                                Balance Amount
                                            </td>
                                            <td>:</td>
                                            <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                                                {data.Balance ?? "-"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>

                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "12px",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                marginTop: "1rem",
                                paddingTop: "0.75rem",
                                borderTop: "0.1px solid rgba(0, 0, 0, 0.08)",
                            }}
                        >
                            <div style={{ fontWeight: "bolder", fontSize: "15px", marginLeft: "100px" }}>
                                Status :{" "}
                                <span style={{ color: statusColor, fontWeight: 600, fontSize: "15px" }}>
                                    {statusText}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "4px",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    marginLeft: "auto",
                                }}
                            >
                            {modifyAccess ? (
                                <span
                                    className="linkylink"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        history.push({
                                            pathname: `/autoadmin/customerspare/${data.id}`,
                                            state: {
                                                editable: true,
                                            },
                                        });
                                    }}
                                >
                                    Modify
                                </span>
                            ) : null}

                            {deleteAccess && (!data.overallStatus || data.overallStatus === "PENDING") ? (
                                <>
                                    {modifyAccess ? <Divider type="vertical" /> : null}
                                    <Popconfirm
                                        title="Are you sure delete this Spare Order"
                                        okText="Yes"
                                        cancelText="No"
                                        onCancel={(event) => {
                                            event.stopPropagation();
                                        }}
                                        onConfirm={(event) => {
                                            event.stopPropagation();
                                            deleteData(data.id);
                                        }}
                                    >
                                        <span
                                            className="linkylink"
                                            onClick={(event) => event.stopPropagation()}
                                        >
                                            Delete
                                        </span>
                                    </Popconfirm>
                                </>
                            ) : null}

                            <Divider type="vertical" />
                            <span
                                className="linkylink"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    window.open(
                                        `${ENDPOINT}api/customerSpareOrderRouter/generatePDF/${data.id}`,
                                        "_blank"
                                    );
                                }}
                            >
                                Print
                            </span>

                            {data.orderType == "COUNTER_SALE" && hasCashCollectAccess && data.Balance > 0 && (
                                <>
                                    <Divider type="vertical" />
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setPaymentOpen(true);
                                            setSelectedData(data);
                                        }}
                                    >
                                        Collect Cash: ₹{data.Balance}
                                    </Button>
                                </>
                            )}

                            {((data.payment && data.payment.length > 0) || Number(data.Advance) > 0) && (
                                <>
                                    <Divider type="vertical" />
                                    <span
                                        className="linkylink"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setReceiptOpen(true);
                                            setSelectedData(data);
                                        }}
                                    >
                                        Receipts
                                    </span>
                                </>
                            )}

                            {data?.orderType == "COUNTER_SALE" &&
                                modifyAccess &&
                                !data?.convertedData &&
                                (data?.overallStatus == "PARTIALLY_RECEIVED" ||
                                    data?.overallStatus == "RECEIVED") && (
                                    <>
                                        <Divider type="vertical" />
                                        <Popconfirm
                                            title="Are you sure you want to convert this order to Counter Sale?"
                                            okText="Yes"
                                            cancelText="No"
                                            onConfirm={(event) => {
                                                event.stopPropagation();
                                                convertAction("convertToCountersale", data.id);
                                            }}
                                            onCancel={(event) => event.stopPropagation()}
                                        >
                                            <span
                                                className="linkylink"
                                                onClick={(event) => event.stopPropagation()}
                                            >
                                                Counter Sale
                                            </span>
                                        </Popconfirm>

                                        <Divider type="vertical" />

                                        <Popconfirm
                                            title="Are you sure you want to convert this order to Job Card?"
                                            okText="Yes"
                                            cancelText="No"
                                            onConfirm={(event) => {
                                                event.stopPropagation();
                                                convertAction("convertToJobcard", data.id);
                                            }}
                                            onCancel={(event) => event.stopPropagation()}
                                        >
                                            <span
                                                className="linkylink"
                                                onClick={(event) => event.stopPropagation()}
                                            >
                                                Job Card
                                            </span>
                                        </Popconfirm>
                                    </>
                                )}

                            {data?.orderType == "COUNTER_SALE" && modifyAccess && data?.convertedData && (
                                <>
                                    <Divider type="vertical" />
                                    <span
                                        className="linkylink"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleConvertedData(data.convertedData);
                                        }}
                                    >
                                        Converted{" "}
                                        {data.convertedData?.module == "JOB_CARD"
                                            ? "Job Card"
                                            : "Counter Sale"}
                                    </span>
                                </>
                            )}

                            {!modifyAccess && !deleteAccess && !hasCashCollectAccess ? (
                                <Text strong disabled>
                                    {" "}
                                    No Access Given
                                </Text>
                            ) : null}
                            </div>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div id="customerSpareOrder">
                <Table
                    rowKey={(record) => record.id}
                    pagination={pagination}
                    columns={column}
                    tableLayout="auto"
                    style={{ cursor: "pointer" }}
                    dataSource={dataSource}
                    onRow={(record) => ({
                        onClick: () => {
                            history.push({
                                pathname: `/autoadmin/customerspare/${record.id}`,
                                state: {
                                    editable: false
                                }
                            })
                        },
                    })}
                    loading={spinner}
                />
            </div>
            {
                paymentOpen && selectedData &&
                <PaymentModal
                    visible={paymentOpen}
                    onClose={() => {
                        setPaymentOpen(false);
                        setSelectedData(null);
                    }}
                    module="CSO"
                    moduleId={selectedData.id}
                    paidBy={selectedData.partyName?.id}
                    collectedBy={loginCredintials?.id}
                    createdBy={loginCredintials?.id}
                    branchId={selectedData.branch?.id}
                    data={selectedData}
                    onSuccess={() => {
                        refreshData();
                    }}
                />
            }

            {
                receiptOpen && selectedData && (
                    <ViewPayments
                        open={receiptOpen}
                        close={() => {
                            setReceiptOpen(false);
                            refreshData();
                        }}
                        data={selectedData?.payment}
                        module="cso"
                    />
                )
            }

            {
                jobOrderVisible &&
                <JobOrderModal
                    open={jobOrderVisible}
                    data={jobDetail}
                    emitData={(data) => addData(data)}
                    editable={false}
                    setEditFlag={false}
                    close={() => {
                        setJobOrderVisible(false);
                        setJobDetail(null);
                    }}
                    isFromCustomer={true}
                />
            }

            {
                customerLedgerOpen && selectedCustomer && (
                    <LedgerModal
                        visible={customerLedgerOpen}
                        onCancel={() => {
                            setCustomerLedgerOpen(false);
                            setSelectedCustomer(null);
                        }}
                        data={selectedCustomer}
                        type="CUSTOMERS"
                        initialSubTab="CSO"
                    />
                )
            }
        </>
    );
};

export default withRouter(CustomerSpareTable);
